import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'saleCenter': {
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'customerCode': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
}

export default {
  'saleCenterName': {
    title: '营销大区名称'
  },
  'saleBase': {
    title: '营销区域'
  },
  'customerCode': {
    title: '客户编号',
  },
  'customerName': {
    title: '客户名称',
    width: 250,
    type: 'input',

  },
  'customerTypeTextView': {
    title: '客户类型',
  },
  'planTypeTextView': {
    title: '计划类型',
  },
  'brand': {
    describe: true,
    suffix: 'Name',
    title: '存货分类',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    width: 200
  },
  'totalPlanQty': {
    title: '2023年签约总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'totalPlanMoney': {
    title: '2023年签约总金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'totalAdviseQty': {
    title: '建议签约总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'totalAdviseMoney': {
    title: '建议签约总金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'centerAuditQty': {
    title: '大区申请签约总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'centerAuditMoney': {
    title: '大区申请签约总金额(万)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'signedQty': {
    title: '已签约总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'signedMoney': {
    title: '已签约总金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  // 'noReportQty': {
  //   title: '未提报总量(件)',
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'noReportMoney': {
  //   title: '未提报总金额(万元)',
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'centerAuditQty': {
  //   title: '大区审批中的总量(件)',
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'centerAuditMoney': {
  //   title: '大区审批中的总金额(万)',
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  // 'signFinishQtyRatio': {
  //   title: '签约量完成比率(%)',
  //   xlsxFmt: {
  //     t: 'n'
  //   }
  // },
  'statusTextView': {
    title: '审批状态'
  }
}



// WEBPACK FOOTER //
// ./src/views/qy-manage/config/signingCompletedDetail.js